import React, { useState, useEffect } from 'react';
import { Typography, Grid, Paper, TextareaAutosize, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import {
	getFeedbackByUser,
	createFeedback,
	updateFeedback,
} from '../../services/feedback.service';
import { ToastsStore, ToastsContainer, ToastsContainerPosition } from 'react-toasts';
import { constants } from 'constants/Constants';
const PREFIX = 'Feedback';

const classes = {
    formElement: `${PREFIX}-formElement`,
    paper: `${PREFIX}-paper`,
    formContainer: `${PREFIX}-formContainer`,
    saveGrid: `${PREFIX}-saveGrid`,
    message: `${PREFIX}-message`,
    form: `${PREFIX}-form`,
    errorMessage: `${PREFIX}-errorMessage`,
    ratingDOM: `${PREFIX}-ratingDOM`,
    title: `${PREFIX}-title`,
    subtitle: `${PREFIX}-subtitle`,
    textArea: `${PREFIX}-textArea`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formElement}`]: {
        marginTop: theme.spacing(2),
        minWidth: '100%',
        backgroundColor:"#042630",
        '&:hover': {
			backgroundColor: "rgba(4, 38, 48, 0.8)",

		},
    },

    [`& .${classes.paper}`]: {
        height: '25rem',
        textAlign: 'center',
    },

    [`& .${classes.formContainer}`]: {
        padding: theme.spacing(2),
    },

    [`& .${classes.saveGrid}`]: {
        marginTop: theme.spacing(2),
    },

    [`& .${classes.message}`]: {
        margingTop: theme.spacing(4),
    },

    [`& .${classes.form}`]: {
        marginTop: theme.spacing(4),
    },

    [`& .${classes.errorMessage}`]: {
        color: 'red',
    },

    [`& .${classes.ratingDOM}`]: {
        marginTop: theme.spacing(4),
    },

    [`& .${classes.title}`]: {
        marginTop: theme.spacing(2),
    },

    [`& .${classes.subtitle}`]: {
        marginTop: theme.spacing(4),
    },

    [`& .${classes.textArea}`]: {
        marginTop: theme.spacing(2),
        minWidth: '85%',
    }
}));

interface Props {
	viewMode: any;
	createFeedback: any;
	errorObj: any;
}
const Feedback = () => {
	const [hover] = React.useState(-1);

	const [value, setValue] = React.useState<number | null>(0);
	const [feedback, setFeedback] = useState({
		id: null,
		rating: 0,
		userId: 0,
		comments: null,
	});
	const [feedbackMsg, setFeefackMsg] = useState('');
	const labels: { [index: string]: string } = {
		1: 'Un-Satisfactory',
		2: 'Poor',
		3: 'Ok',
		4: 'Good',
		5: 'Excellent',
	};

	const submitForm = async () => {
		const requestData = {
			rating: value,
			comments: feedbackMsg,
		};
		try {
			let resp: any;
			if (feedback.id === null) {
				resp = await createFeedback(requestData);
				setFeedback(resp.data.data);
			} else {
				resp = await updateFeedback(feedback.id, requestData);
			}

			if (
				resp !== undefined &&
				resp.data &&
				resp.data.errors !== undefined &&
				resp.data.errors.length === 0
			) {
				ToastsStore.success('Feedback saved successfully', 8000, 'toast-styles');
			} else if (resp === 'error') {
				ToastsStore.error('Feedback creation failed ', 8000);
			}
		} catch (errorObj) {
			//setHasError(errorObj);
		}
	};
	// Get feedback
	useEffect(() => {
		const getFeedback = async () => {
			const getFeedbackObj = await getFeedbackByUser();
			setFeedback(getFeedbackObj);
			setValue(getFeedbackObj.rating);
			setFeefackMsg(getFeedbackObj.comments);
		};
		getFeedback();
	}, []);
	return (
        <Root>
                <ToastsContainer
                    className="toast"
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_CENTER}
                />
                <Paper variant="outlined" className={classes.paper} style={{border:"1px solid #cccccc", margin:"15px",height: '25rem',
        textAlign: 'center',}}>
                    <Typography component="h1" variant="h1" className={classes.title} style={{fontSize:"2rem"}}>
                        We would love to hear from you
                    </Typography>

                    <Typography
                        className={classes.subtitle}
                        noWrap={true}
                        variant="subtitle1">
                        We value your opinion..Help us enhance your experience with
                        bellplus..!! Rate your experience in creating the campaign and total
                        work flow with us..
                    </Typography>
                    <Grid container>
                        <Grid item xs={12}>
                            <TextareaAutosize
                                value={feedbackMsg !== 'null' ? feedbackMsg : ''}
                                className={classes.textArea}
                                aria-label="minimum height"
                                minRows={3}
                                onChange={(e) => {
                                    setFeefackMsg(e.target.value);
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Rating
                        className={classes.ratingDOM}
                        name="hover-feedback"
                        value={value}
                        precision={0.1}
                        onChange={(event, newValue) => {
                            setValue(newValue);
                            // submitForm(newValue);
                        }}
                    />
                    {value !== null && (
                        <Box ml={2}>{labels[hover !== -1 ? hover : value]}</Box>
                    )}
                    <Grid
                        container
                        item
                        direction="row"
                        justifyContent="center"
                        className={classes.saveGrid}>
                        <Grid item>
                            <Button
                                className={classes.formElement}
                                variant="contained"
                                type="submit"
                                onClick={submitForm}>
                                {constants.SAVE}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Root>
    );
};

export default Feedback;
